import React from 'react';
import classNames from 'classnames';
import CourseCard from '../atoms/course-card';

const CourseList = ({ className, items, prefix }) => {
  return (
    <section className={classNames('course-list', className)}>
      <div className="course-list__inner container">
        {items.map(({ node }) => {
          const { id, title, slug, featured_media: featuredMedia, excerpt: body } = node;
          const { tagline: subtitle } = node.acf;

          return (
            <div className="course-list__item" key={id}>
              <CourseCard
                prefix={prefix}
                title={title}
                slug={slug}
                image={featuredMedia}
                subtitle={subtitle}
                body={body}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default CourseList;
